import image from './project.svg';
import './project.css'

import Card from './Card';
function Project() {
    return (
        <div className='project-pro-up'>

            <div className='project-pro'>
                <h1 >  &lt;  Projects  /&gt;</h1>

                <div className='project-main'>

                    <div className='project-body'>
                        <img src={image} alt='project-image' />

                    </div>
                    <div className='project-text'>
                        <p>
                            My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.
                        </p>
                    </div>
                </div>

                <Card />
            </div>
        </div>
    )
}
export default Project;